import { Typography } from '@euler/app/components/typography';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode, useCallback, useEffect } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';

export const TagButton = memo(
  ({
    name,
    active,
    style,
    icon,
    color = 'orange',
    onPress,
  }: {
    name: string;
    active?: boolean;
    icon?: ReactNode;
    color?: string;
    style?: StyleProp<ViewStyle>;
    onPress?: (name: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();

    const handlePress = useCallback(() => {
      onPress?.(name);
    }, [name, onPress]);

    const scale = useSharedValue(1);

    useEffect(() => {
      scale.value = active ? 1.3 : 1;
    }, [active, scale]);

    const animatedStyle = useAnimatedStyle(() => ({
      transform: [{ scale: withTiming(scale.value, { duration: 200 }) }],
    }));

    return (
      <Animated.View
        css={`
          min-height: ${rpx(60)}px;
          min-width: ${rpx(60)}px;
        `}
        style={[animatedStyle, style]}
      >
        <TouchableOpacity
          onPress={handlePress}
          css={`
            flex: 1;
            align-items: center;
            justify-content: center;
          `}
        >
          {icon ?? <Icon name="alert-octagon" size={rpx(26)} color={color} />}
          <Typography.Label
            light
            size={rpx(13)}
            color="#fff"
            css={`
              margin-top: ${rpx(4)}px;
            `}
          >
            {name}
          </Typography.Label>
        </TouchableOpacity>
      </Animated.View>
    );
  },
);
